<template>
  <page style="background: #fff;">
    <div class="text-center" style="padding: 50px 0;">
      <div class="text-3xl font-bold text-gray-700">欢迎使用</div>
      <img class="logo" src="@/assets/ap-logo.png" />
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.logo{
  width: 360px;
  margin-top: 40px;
  opacity: 0.65;
}
</style>
